module.exports = __webpack_public_path__ + "img/01-T.b79be74f.png";